import React from 'react';
import { Container } from 'react-bootstrap';
import PositionsTable from '../../components/custom/PositionsTable';

const ExistingPositions = ({ embedded = false }) => {
  const content = <PositionsTable mode="stackRanking" />;

  if (embedded) {
    return <div style={{ overflowX: 'auto' }}>{content}</div>;
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--ds-bg)', padding: '24px 0', width: '100%', maxWidth: '100%' }}>
      <Container fluid="lg" style={{ maxWidth: '100%', paddingLeft: 16, paddingRight: 16 }}>{content}</Container>
    </div>
  );
};

export default ExistingPositions;
